import axios from "axios";

const axiosInstance = axios.create({
    // baseURL: "http://localhost:9191/",
    baseURL:"https://147.93.28.177:9191/",
});

export default axiosInstance;